import { getConditions, getTimeSlots, scheduleVideoVisit, ambulatorySurveyRequest } from "../api/epicApi";
import { getVideoVisitTermsAndConditions, acceptVideoVisitTermsAndConditions, getVideoVisitUrl } from "../api/portalApi";
import * as types from "../constants/actionTypes";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { logAPI } from "../api/andyliticsApi";

export default function* videoVisitSchedulingSaga() {
    yield takeLatest([types.GET_VIDEO_VISIT_CONDITIONS], handleVideoVisit);
    yield takeLatest([types.GET_VIDEO_VISIT_TIME_SLOTS], handleVideoVisit);
    yield takeLatest([types.SCHEDULE_VIDEO_VISIT_REQUEST], handleVideoVisit);
    yield takeLatest([types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST], handleVideoVisit);
    yield takeLatest([types.GET_VIDEO_VISIT_TERMS], handleVideoVisit);
    yield takeLatest([types.ACCEPT_VIDEO_VISIT_CONDITIONS], handleVideoVisit);
    yield takeLatest([types.GET_VIDEO_VISIT_LINK], handleVideoVisit);
}

export function* handleVideoVisit(payload) {
    const start = new Date();
    const domain = yield select((state) => state.domain);
    const activityCode = "MBHWeb.Saga.VideoVisitScheduling.";

    if (domain && domain.t) {
        try {
            switch (payload.type) {
                case types.GET_VIDEO_VISIT_CONDITIONS:
                    try {
                        yield put({ type: types.GET_VIDEO_VISIT_CONDITIONS_PENDING });
                        const response = yield call(getConditions, domain.t);
                        logAPI(activityCode + "GetVideoVisitConditions.Success", start, null);
                        yield put({ type: types.GET_VIDEO_VISIT_CONDITIONS_SUCCESS, conditions: response });
                    }
                    catch (err) {
                        yield put({ type: types.GET_VIDEO_VISIT_CONDITIONS_FAILURE });
                        console.error(err);
                        logAPI(activityCode + "GetVideoVisitConditions.Failure", start, null, JSON.stringify(err));
                    }
                    break;
                case types.GET_VIDEO_VISIT_TIME_SLOTS:
                    try {
                        if (payload && payload.data && payload.data.clientUTCOffset && payload.data.date) {
                            let clientUTCOffset = payload.data.clientUTCOffset;
                            let date = payload.data.date;
                            yield put({ type: types.GET_VIDEO_VISIT_TIME_SLOTS_PENDING });
                            const response = yield call(getTimeSlots, domain.t, clientUTCOffset, date);
                            if (response && response.availableTimes) {
                                logAPI(activityCode + "GetVideoVisitTimeSlots.Success", start, null);
                                yield put({ type: types.GET_VIDEO_VISIT_TIME_SLOTS_SUCCESS, timeslots: response });
                            }
                            else {
                                yield put({ type: types.GET_VIDEO_VISIT_TIME_SLOTS_FAILURE });
                                logAPI(activityCode + "GetVideoVisitTimeSlots.Failure", start, null, response);
                            }
                        }
                    } catch (err) {
                        yield put({ type: types.GET_VIDEO_VISIT_TIME_SLOTS_FAILURE });
                        console.error(err);
                        logAPI(activityCode + "GetVideoVisitTimeSlots.Failure", start, null, JSON.stringify(err));
                    }
                    break;
                case types.SCHEDULE_VIDEO_VISIT_REQUEST:
                    try {
                        yield put({ type: types.SCHEDULE_VIDEO_VISIT_REQUEST_PENDING });
                        const response = yield call(scheduleVideoVisit, domain.t, payload);
                        if (response && response.csn) {                           
                            logAPI(activityCode + "ScheduleVideoVisit.Success", start, null, JSON.stringify(payload));
                            yield put({ type: types.SCHEDULE_VIDEO_VISIT_REQUEST_SUCCESS, response: response });
                        }
                        else {
                            yield put({ type: types.SCHEDULE_VIDEO_VISIT_REQUEST_FAILURE });                           
                            logAPI(activityCode + "ScheduleVideoVisit.Failure", start, null, JSON.stringify({"response": response, "payload": payload }));
                        }
                    } catch (err) {
                        yield put({ type: types.SCHEDULE_VIDEO_VISIT_REQUEST_FAILURE });
                        logAPI(activityCode + "ScheduleVideoVisit.Failure", start, null, JSON.stringify({ "error": err, "payload": payload }));
                    }
                    break;
                case types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST:
                    try {
                        yield put({ type: types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_PENDING });
                        if (!domain.t) {
                            yield put({ type: types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_FAILURE });
                            break;
                        }
                        const response = yield call(ambulatorySurveyRequest, domain.t, payload);
                        if (response === 200) {
                            logAPI(activityCode + "AmbulatoryCareSurvey.Success", start, null);
                            yield put({ type: types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_SUCCESS });
                        }
                        else {
                            yield put({ type: types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_FAILURE });
                            logAPI(activityCode + "AmbulatoryCareSurvey.Failure", start, null, response);
                        }
                    } catch (err) {
                        yield put({ type: types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_FAILURE });                       
                        logAPI(activityCode + "AmbulatoryCareSurvey.Failure", start, null, JSON.stringify(err));
                    }
                    break;
                case types.GET_VIDEO_VISIT_TERMS:
                    try {
                        yield put({ type: types.GET_VIDEO_VISIT_TERMS_PENDING });
                        const response = yield call(getVideoVisitTermsAndConditions, domain.un, domain.t, "SameDayCare", domain.cu && domain.cu.ei ? domain.cu.ei : null);
                        logAPI(activityCode + "GetVideoVisitTerms.Success", start, null);
                        yield put({ type: types.GET_VIDEO_VISIT_TERMS_SUCCESS, terms: response });

                    } catch (err) {
                        yield put({ type: types.GET_VIDEO_VISIT_TERMS_FAILURE });
                        console.error(err);
                        logAPI(activityCode + "GetVideoVisitTerms.Failure", start, null, JSON.stringify(err));
                    }
                    break;
                case types.ACCEPT_VIDEO_VISIT_CONDITIONS:
                    try {
                        yield put({ type: types.ACCEPT_VIDEO_VISIT_CONDITIONS_PENDING });
                        const response = yield call(acceptVideoVisitTermsAndConditions, domain.t, domain.un, payload.data.versionId, payload.data.proxyId);
                        logAPI(activityCode + "AcceptTermsAndConditions.Success", start, null);
                        yield put({ type: types.ACCEPT_VIDEO_VISIT_CONDITIONS_SUCCESS, response: response });
                    }
                    catch (err) {
                        yield put({ type: types.ACCEPT_VIDEO_VISIT_CONDITIONS_FAILURE });
                        console.error(err);
                        logAPI(activityCode + "AcceptTermsAndConditions.Failure", start, null, JSON.stringify(err));
                    }
                    break;
                //case types.GET_VIDEO_VISIT_LINK:
                //    try {
                //        let videoVisitLink = yield call(getVideoVisitUrl, domain.t, domain.un, payload.csn);
                //        videoVisitLink.csn = payload.csn;
                //        logAPI(activityCode + "GetVideoVisitLink.Success", start, null, videoVisitLink);
                //        yield put({ type: types.GET_VIDEO_VISIT_LINK_SUCCESS, videoVisitLink });
                //    } catch (error) {
                //        let csn = payload && payload.csn ? payload.csn : null
                //        yield put({ type: typse.GET_VIDEO_VISIT_LINK_FAILURE, error, csn });
                //        console.error(error);
                //        logAPI(activityCode + "GetVideoVisitLink.Failure", start, null, JSON.stringify(error));
                //    }
                //    break;
            }
        } catch (err) {
            console.error(err);
            logAPI(activityCode + "Failure", start, null, JSON.stringify(err));
        }
    } else {
        console.log("Error");
    }
};